import { createAction, props, union } from '@ngrx/store';

import { PaymentStatus } from '../../interfaces/payment.interface';

export const setPaymentStatus = createAction('[PaymentActions] SetPaymentStatus', props<{ status: PaymentStatus }>());
export const setPaymentRedirectionUrl = createAction(
  '[PaymentActions] SetPaymentRedirectionUrl',
  props<{ url: string }>()
);

const _all = union({ setPaymentStatus, setPaymentRedirectionUrl });

export type ActionsUnion = typeof _all;
